import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import ProductUtils from "../../../../utils/product-utils";
import {Product} from "../../../../model/product";
import {Property} from "../../../../model/property";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import {ObjectOwnerComponent} from "../../../object-owner/object-owner.component";
import {ObjectOwner} from "../../../../model/object-owner";
import {FolioNumberComponent} from "../../../folio-number/folio-number.component";
import {LandregisterfolioUtils} from "../../../../utils/LandregisterfolioUtils";

@Component({
  selector: 'app-grunde-information-modal',
  templateUrl: './grunde-information-modal.component.html',
  styleUrls: ['./grunde-information-modal.component.css']
})
export class GrundeInformationModalComponent implements OnInit {

  grundeProduct: Product
  selectedProperty: Property;

  @ViewChild(ObjectOwnerComponent) objectOwnerComponent: ObjectOwnerComponent;
  @ViewChild(FolioNumberComponent) folioNumberComponent: FolioNumberComponent;
  @ViewChild('checkboxRef') checkbox: ElementRef<HTMLInputElement>;

  protected readonly ProductUtils = ProductUtils;
  protected readonly faInfoCircle = faInfoCircle;

  constructor(public dialogRef: MatDialogRef<GrundeInformationModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  /**
   * Initializes the component:
   * - Sets the first product from the dialog data as 'grundeProroduct'
   * - Sets the selected property from the dialog data
   */
  ngOnInit(): void {
    this.grundeProduct = this.data?.products?.[0] ?? undefined;
    this.selectedProperty = this.data?.selectedProperty ?? undefined;
  }

  /**
   * Handles closing of the modal dialog.
   * Sets a localStorage flag if the checkbox is checked to supress future display of this modal.
   * When closed emits a boolean indicating whether the dialog should be shown again
   */
  public addGrundeDocument(): void {
    if(this.data.isConnectOrigin) {
      const isCheckboxChecked = this.checkbox.nativeElement.checked
      if(isCheckboxChecked) {
        localStorage.setItem("grundeInformationModal", String(true));
      }
    }
    else{
      // Checks if the forms are valid. If not automatically marks all invalid inputs
      const isObjectOwnerFormValid = this.objectOwnerComponent?.isObjectOwnerFormValid();
      const isFolioNumberFormValid = this.folioNumberComponent?.isFolioNumberFormValid();

      if (!isObjectOwnerFormValid || !isFolioNumberFormValid) {
        return;
      }

      this.selectedProperty.objectOwnerList = this.objectOwnerComponent.objectOwners.controls.map(group => {
        const value = group.value;
        return {
          firstname: value.firstname?.trim() ?? '',
          lastname: value.lastname?.trim() ?? '',
          birthDate: value.birthDate ?? null,
          birthName: value.birthName?.trim() ?? '',
          company: value.company?.trim() ?? '',
          objectOwnerType: value.objectOwnerType
        } as ObjectOwner;
      });

      const formValues = this.folioNumberComponent.folioNumberForm.get('numbers')?.value ?? [];

      LandregisterfolioUtils.createFoliosIfMissing(this.selectedProperty);
      LandregisterfolioUtils.assignFolioNumbers(this.selectedProperty.landregisterfolios, formValues);
      this.selectedProperty.dataResearch = this.folioNumberComponent.folioNumberForm.get('dataResearch')?.value ?? false;
    }

    this.dialogRef.close(true);
  }

  /**
   * Closes the currently open modal dialog.
   */
  public closeModal(): void {
    this.dialogRef.close(false);
  }
}
